import { Alert, Box } from '@mui/material'
import WhatsappPageHeader from '../../components/whatsapp/WhatsappPageHeader'
import { predefinedVariables } from '../../components/whatsapp/SokolinkVars'

function Param({ param }) {
  const { name, description, example } = param
  return (
    <tr className="param">
      <td style={{ minWidth: '150px', textAlign: 'start' }}>
        <p style={{ padding: '10px' }}>{name}</p>
      </td>
      <td style={{ minWidth: '100px', textAlign: 'start' }}>
        <p>{description}</p>
      </td>
      <td style={{ minWidth: '100px', textAlign: 'start' }}>
        <p>{example}</p>
      </td>
    </tr>
  )
}

export default function SokolinkParamsPage() {
  return (
    <Box className="page-content">
      <WhatsappPageHeader activeTab="params" />
      <Alert severity="info" sx={{ my: 1 }}>This is a list of Sokolink system name parameters you can use when creating your message templates. These parameters are reserved and will be replaced with their values from Sokolink.</Alert>
      <div className="table-container">
        <table className="templates-table">
          <thead>
            <tr>
              <th style={{ textAlign: 'start' }}>Name</th>
              <th style={{ textAlign: 'start' }}>Description</th>
              <th style={{ textAlign: 'start' }}>Example</th>
            </tr>
          </thead>
          <tbody>
            {predefinedVariables.map((p) => <Param key={p.name} param={p} />)}
          </tbody>
        </table>
      </div>
    </Box>
  )
}
